import { z } from 'zod';

export const taxSavingsSimulatorFormSchema = z.object({
  householdAnnualIncome: z.coerce.number().min(0),
  taxSharesHousehold: z.coerce.number(),
});

export type TaxSavingsSimulatorFormSchema = z.infer<
  typeof taxSavingsSimulatorFormSchema
>;
